import React from "react";

function Footer() {
    return (
        <>
            <footer className="footer">
                <p lang="en" className="footer__copyright">&copy; 2022 Mesto Russia</p>
            </footer>
        </>
    );
}

export default Footer;
